import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _ from 'underscore';
import { ApplicationService } from 'src/app/services/application.service';
import { AuthenticateService } from 'src/app/services/authenticate.service';
import { ApiResponse } from 'src/app/interfaces/api-response';

@Component({
  selector: 'app-auth0-login',
  styleUrls: ['./auth0-login.component.scss'],
  templateUrl: 'auth0-login.component.html',
  animations: [
    trigger('openClose', [
      state('open', style({ opacity: 1 })),
      state('closed', style({ opacity: 0 })),
      transition('open => closed', [animate('1s')]),
      transition('closed => open', [animate('1.2s')]),
    ]),
  ],
  standalone: false,
})
export class Auth0LoginComponent implements OnInit {
  loading = false;
  isOpen = false;
  isOpen2 = false;
  isOpen3 = false;
  isOpen4 = false;
  isOpen5 = false;
  tagLineComplete = 'Your home for';
  tagLine = '';
  count = 0;
  textInterval: any;
  redirectUrl = '';
  bg: SafeUrl = '';
  showContent = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private applicationService: ApplicationService,
    private authenticateService: AuthenticateService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.applicationService.setLanguage();
    sessionStorage.clear();

    this.applicationService.getAppVersion(false).then(() => {
      sessionStorage.removeItem('unverified');
      this.applicationService.deleteStoredItem('accountCode');
      this.applicationService.deleteStoredItem('ab-test');

      this.authenticateService.deleteTokens();

      this.redirectUrl =
        this.route.snapshot.queryParamMap.get('redirectUrl') &&
        this.route.snapshot.queryParamMap.get('redirectUrl').indexOf('Logout') < 0
          ? `${this.route.snapshot.queryParamMap.get('redirectUrl')}${window.location.hash}`
          : '';

      this.bg = this.formatUrl(this.getBg());

      setInterval(() => {
        const img = new Image();
        const bg = this.getBg();
        img.src = String(bg);
        setTimeout(() => {
          this.bg = this.formatUrl(bg);
        }, 1000);
      }, 5000);

      this.showContent = true;

      setTimeout(() => {
        this.isOpen5 = true;
        this.textInterval = setInterval(() => {
          this.tagLine = this.tagLineComplete.substr(0, this.count);
          this.count++;
          if (this.count > this.tagLineComplete.length) {
            clearInterval(this.textInterval);
            this.showTagLines();
          }
        }, 50);
      }, 200);
    });
  }

  signInWithAuth0(): void {
    this.loading = true;
    this.authenticateService.idpLogin();
  }

  private showTagLines(): void {
    this.isOpen = true;
    setTimeout(() => { this.isOpen2 = true; }, 500);
    setTimeout(() => { this.isOpen3 = true; }, 1000);
    setTimeout(() => { this.isOpen4 = true; }, 1500);
  }

  private getBg(): string {
    const base = 'assets/images/';
    const bgs = [
      base + 'Login_4.jpg',
      base + 'Login_5.jpg',
      base + 'Login_6.jpg',
    ];
    return String(_.sample(_.without(bgs, String(this.bg))));
  }

  formatUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
  }
}
